module.exports = (__webpack_require__(6))(571);


//////////////////
// WEBPACK FOOTER
// delegated ./src/main/webapp/app/vendor.ts from dll-reference vendor
// module id = 327
// module chunks = 0